import React, {useEffect} from 'react';
import classNames from 'classnames';
import {map} from 'lodash';
import {useDispatch} from 'react-redux';

import {editActivity, newActivity} from 'shared/portfolio/actions/activities';
import {Activity as ActivityType} from './activities-form-wrapper';

import TwoColumnMasonry from 'shared/portfolio/components/two-column-masonry';
import ActivityFormCard from 'shared/portfolio/components/activities/activities-form-card';
import Card from '../card';
import Section from '../section';
import Activity from './activity';

interface Props {
  activityType: 'Activities' | 'Sports';
  activities: ActivityType[];
}

const Activities = ({activities, activityType}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.Raise.vent.on('add:activity', () => {
      dispatch(newActivity());
    });
  }, [dispatch]);

  return (
    <Section>
      <div className="portfolio-section-wrapper-header">{activityType}</div>
      <TwoColumnMasonry>
        {map(activities, (activity) => {
          if (activity.editing) {
            return (
              <div
                key={activity._id}
                className={classNames('portfolio-sections column', {
                  editing: activity.editing,
                })}
              >
                <ActivityFormCard activity={activity} />
              </div>
            );
          } else {
            return (
              <div key={activity._id} className="portfolio-sections column">
                <Card
                  id={activity._id}
                  active={!!activity.scrollTo}
                  onClick={() => {
                    dispatch(editActivity({...activity, scrollTo: true}));
                  }}
                >
                  <Activity activity={activity} />
                </Card>
              </div>
            );
          }
        })}
      </TwoColumnMasonry>
    </Section>
  );
};

export default Activities;
